/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {useSelector} from 'react-redux'
import {AppRootState} from '../model/config'
import {Module} from '../model/apps'

const filterAccessibleModules = (module: Module) => {
  return module.apps?.find((app) => app.hasAccess) !== undefined
}

const useRegisteredModules = (fetchAll?: boolean) => {
  const filterFunc = fetchAll ? () => true : filterAccessibleModules

  const registeredModules = useSelector(
    (state: AppRootState) => state.app.registeredModules
  ).filter(filterFunc)

  return [registeredModules]
}

export default useRegisteredModules
